import * as Icons from "lucide-react";
import { MODULES } from "../lib/brand";
import { CTA, GlassCard, PageHeader, SectionHeading, Shell } from "../components/site/Primitives";
import ReceptionistDemo from "../components/site/ReceptionistDemo";

const GROUPS = [
  ["Conversation", ["AI Receptionist", "AI Sales Agent", "SMS", "WhatsApp", "Email Automation"]],
  ["Revenue", ["CRM", "AI Lead Qualification", "Appointment Scheduling", "Payments"]],
  ["Operations", ["Workflow Automation", "Automated Follow-Up", "Team Management", "Customer Management"]],
  ["Intelligence", ["Analytics", "AI Reporting"]],
];

export default function Features() {
  return (
    <div data-testid="features-page">
      <PageHeader
        testId="features-title"
        eyebrow="Features"
        title="Give your team one place to manage every customer interaction."
        sub="A complete feature set organised around four jobs: conversation, revenue, operations and intelligence."
      />

      <section className="py-20">
        <Shell>
          <div className="grid gap-3 lg:grid-cols-4">
            {GROUPS.map(([group, items], gi) => (
              <GlassCard key={group} testId={`feature-group-${gi}`} className="p-5">
                <p className="text-[11px] uppercase tracking-[0.24em] text-elv-green">{group}</p>
                <ul className="mt-5 space-y-3">
                  {items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-elv-dim">
                      <Icons.Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-elv-cyan" />
                      {item}
                    </li>
                  ))}
                </ul>
              </GlassCard>
            ))}
          </div>
        </Shell>
      </section>

      <section className="border-y border-elv-line bg-[#070A0F] py-20">
        <Shell>
          <SectionHeading
            testId="features-detail-heading"
            eyebrow="Module detail"
            title="What each module actually does."
          />
          <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {MODULES.map(([name, description, benefit], i) => (
              <GlassCard key={name} testId={`features-module-${i}`} className="p-5">
                <p className="text-sm font-semibold text-elv-text">{name}</p>
                <p className="mt-2 text-xs leading-relaxed text-elv-dim">{description}</p>
                <p className="mt-3 text-xs text-elv-cyan/90">{benefit}</p>
              </GlassCard>
            ))}
          </div>
        </Shell>
      </section>

      <section className="py-20">
        <Shell>
          <SectionHeading
            testId="features-receptionist-heading"
            eyebrow="In practice"
            title="A booking, from ring to confirmed."
            sub="A demonstration of the receptionist flow. Live behaviour requires your own voice, calendar and messaging credentials."
          />
          <div className="mt-12">
            <ReceptionistDemo />
          </div>
          <div className="mt-12">
            <CTA to="/book-demo" testId="features-cta">
              Build My AI Workforce
            </CTA>
          </div>
        </Shell>
      </section>
    </div>
  );
}
